/** 활동 팝업 보내는 사람 아이콘 */
export const SEND_WALLET_IMG_PATH = 'images/wallet-img.png';

/** 활동 팝업 받는 사람 아이콘 */
export const RECEIVE_WALLET_IMG_PATH = 'images/wallet-img2.png';

/** 뒤로가기 아이콘 */
export const BACK_ICON_PATH = 'images/back-icon.png';

/** alert 아이콘 */
export const ALERT_ICON_PATH = 'images/alert-icon.png';

/** T Logo 아이콘 */
export const T_LOGO_ICON_PATH = 'images/gdf-title.png';
// export const T_LOGO_ICON_PATH = 'img/Logo_header_symboltext.png';

/** asset reset 아이콘 */
export const ASSET_RESET_ICON_PATH = 'images/refresh-icon.png';

/** 트론 SYMBOL 아이콘 */
export const SOL_SYMBOL_ICON_PATH = 'images/sol-symbol.png';

/** 더블에서 SYMBOL 아이콘 */
export const TOKEN_SYMBOL_ICON_PATH = 'images/gdf-logo.png';

export const ASSET_CARD_ICON_PATH = 'images/golden-icon.png';
